/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, inject, ChangeDetectionStrategy, input, computed } from '@angular/core'
import { ConfigService } from '../../services/configuration/config.service'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { PHeader } from '@porsche-customer/navigate-header/angular'

@Component({
  selector: 'myprofile-navigation',
  templateUrl: './navigation.component.html',
  imports: [PorscheDesignSystemModule, PHeader],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  navMode = input<'navbar' | 'hero' | 'transparent'>('navbar')
  navTheme = input<'light' | 'dark'>('light')

  readonly env = computed(() => (this._configService.isProduction() ? 'production' : 'preview'))
  readonly locale = computed(() => this.parseLocale())

  _configService: ConfigService = inject(ConfigService)

  /**
   * This function replaces the underscore with a dash, because it is the needed format for the new navigation
   * Example: de_DE -> de-DE
   */
  private parseLocale(): string {
    const urlLocale = this._configService.getUrlLocale()
    const urlCountry = this._configService.getUrlCountry()
    if (urlLocale && urlCountry) {
      // Special handling for the UAE, as Navigation has different locales for Arabic and English
      if (urlCountry === 'xa') {
        return urlLocale === 'en_GB' ? 'en-AE-x-abu-dhabi' : 'ar-AE-x-abu-dhabi'
      } else if (urlCountry === 'xd') {
        return urlLocale === 'en_GB' ? 'en-AE-x-dubai' : 'ar-AE-x-dubai'
      }
      return `${urlLocale.substring(0, 2).toLowerCase()}-${urlCountry.toUpperCase()}`
    }
    return ''
  }
}
